/* eslint-disable consistent-return */
import { notification } from 'antd'
import { history } from 'index'
import Cookies from 'js-cookie'
import { handelError } from 'utils'
import apiClient from '../index'

export const getListOfEmployee = async (params) => {
  const { skip, limit, userRole, locationId } = params
  try {
    return await apiClient.get('employee', {
      params: {
        skip,
        limit,
        userRole,
        locationId,
      },
    })
  } catch (error) {
    handelError(error)
  }
}
export const getListOfAgent = async (params) => {
  const { status, skip, limit, employeeName } = params
  try {
    return await apiClient.get('employee/allAgents', {
      params: {
        status,
        skip,
        limit,
        employeeName,
      },
    })
  } catch (error) {
    handelError(error)
  }
}

export const getListofAgentHistory = async (params) => {
  const { skip, limit, userId, trainingType, status } = params
  try {
    return await apiClient.get('employee/agentHistory', {
      params: {
        skip,
        limit,
        userId,
        trainingType,
        status,
      },
    })
  } catch (error) {
    handelError(error)
  }
}
export const assignTrainer = async ({ id, userId }) => {
  try {
    return await apiClient.put(`employee/assignTrainer/${id}/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const trainerDetailsUpdate = async ({ userId, trainerId }) => {
  try {
    return await apiClient.patch(`employee/updateTrainerDetails/${userId}/${trainerId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const agentsTrainerDetailsUpdate = async (data) => {
  try {
    return await apiClient.patch(`employee/updateTrainerDetails/multiple`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const filterEmployee = async (params) => {
  const { skip, limit, employeeName, locationId, depId, userProcess } = params
  try {
    return await apiClient.get(`employee/filterEmployee`, {
      params: {
        skip,
        limit,
        employeeName,
        locationId,
        depId,
        userProcess,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const getTeamsEmpList = async ({ locationId, depId, processId }) => {
  try {
    return await apiClient.get(`employee/empListForTeam`, {
      params: {
        locationId,
        depId,
        processId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}

export const updateEmployeeData = async (data) => {
  try {
    return await apiClient.patch('employee', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      Cookies.remove('accessToken')
      history.push('/auth/login')
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateAgentData = async (data) => {
  try {
    return await apiClient.patch('employee/updateAgent', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateMultipleAgentData = async (data) => {
  try {
    return await apiClient.patch('employee/updateMultipleAgent', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateAgentStatus = async (data) => {
  try {
    return await apiClient.patch('employee/updateAgentStatus', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updateMultipleAgentsStatus = async (data) => {
  try {
    return await apiClient.patch('employee/updateMultipleAgentsStatus', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const deleteEmployee = async ({ userId, empId }) => {
  try {
    return await apiClient.delete(`employee/${userId}/${empId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const fetchNewEmpId = async (data) => {
  try {
    return await apiClient.get('employee/getNewEmpId', {
      params: {
        data,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const addNewEmployee = async (empData) => {
  try {
    return await apiClient.post('employee', empData)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const addNewCandidate = async (Data) => {
  try {
    return await apiClient.post('/candidate', Data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const getCandidateList = async (params) => {
  const { skip, limit, status, filterSkill, filterSkillLevel, grade } = params
  try {
    return await apiClient.get(`candidate/candidateList`, {
      params: {
        skip,
        limit,
        status,
        filterSkill,
        filterSkillLevel,
        grade,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const updatedCandidateData = async (data) => {
  try {
    return await apiClient.patch('candidate/updateCandidate', data)
  } catch (error) {
    if (error?.response?.data?.statusCode === 401) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const getUserInfo = async ({ userId }) => {
  try {
    return await apiClient.get(`userInfo/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
}
export const addResignation = async (data) => {
  try {
    return await apiClient.post('employee/addResignation', data)
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const getListOfResignation = async (params) => {
  const { skip, limit, searchedEmp, status } = params
  try {
    return await apiClient.get('employee/getResignations', {
      params: {
        skip,
        limit,
        searchedEmp,
        status,
      },
    })
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const deleteResignation = async (id) => {
  try {
    return await apiClient.put(`employee/deleteResignation/${id}`)
  } catch (error) {
    if (error) {
      notification.error({
        message: error?.message,
      })
    }
  }
  return null
}
export const updateResignation = async (data, id) => {
  try {
    return await apiClient.patch(`employee/updateResignation/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

// export const uploadProfilePicture = async (empData) => {
//   try {
//     return await apiClient.post('media/image', empData)
//   } catch (error) {
//     if (error?.response?.data?.statusCode) {
//       notification.error({
//         message: 'Error',
//         description: error?.response?.data?.message,
//       })
//     }
//   }
// }

export const getEmployeeData = async ({ userId }) => {
  try {
    return await apiClient.get(`employee/data/${userId}`)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
